/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AccessTokenCredentials = {
  accessToken: string;
};

/** @internal */
export const AccessTokenCredentials$inboundSchema: z.ZodType<
  AccessTokenCredentials,
  z.ZodTypeDef,
  unknown
> = z.object({
  access_token: z.string(),
}).transform((v) => {
  return remap$(v, {
    "access_token": "accessToken",
  });
});
/** @internal */
export type AccessTokenCredentials$Outbound = {
  access_token: string;
};

/** @internal */
export const AccessTokenCredentials$outboundSchema: z.ZodType<
  AccessTokenCredentials$Outbound,
  z.ZodTypeDef,
  AccessTokenCredentials
> = z.object({
  accessToken: z.string(),
}).transform((v) => {
  return remap$(v, {
    accessToken: "access_token",
  });
});

export function accessTokenCredentialsToJSON(
  accessTokenCredentials: AccessTokenCredentials,
): string {
  return JSON.stringify(
    AccessTokenCredentials$outboundSchema.parse(accessTokenCredentials),
  );
}
export function accessTokenCredentialsFromJSON(
  jsonString: string,
): SafeParseResult<AccessTokenCredentials, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AccessTokenCredentials$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AccessTokenCredentials' from JSON`,
  );
}
